export const GET_SEDES_REQUEST = 'GET_SEDES_REQUEST';
export const GET_SEDES_SUCCESS = 'GET_SEDES_SUCCESS';
export const GET_SEDES_FAILURE = 'GET_SEDES_FAILURE';
